import React, { useCallback } from "react"
import clsx from "clsx"
import { Icon, Logo } from "@silversea-ssc/ui-components-react"
import { Trans } from "@lingui/macro"
import { useGeolocation } from "../../app-core/_common/providers/geolocation-provider"
import { scrollToElement } from "../scrollToElement"
import { useECommerceMachine } from "../../app-core/_common/machines/machines-context"
import { WebQuoteExitIntent } from "../../app-core/v3/_common/web-quote-exit-intent"
import styles from "./Header.module.scss"

type Props = {
    className?: string
    webQuoteExitIntent: WebQuoteExitIntent
}

const Header: React.FC<Props> = ({ className, webQuoteExitIntent }) => {
    const logoClick = () => {
        if (webQuoteExitIntent.canTrigger) {
            webQuoteExitIntent.openExitIntentModal()
        } else {
            window.location.href = "https://www.silversea.com"
        }
    }

    return (
        <header className={clsx(styles.header, className)}>
            <div className={styles.container}>
                <button style={{ display: "block" }} data-content-piece="logo" title="Silversea" onClick={logoClick}>
                    <Logo width={180} mobileWidth={145} />
                </button>
                <div className={styles.links}>
                    <SupportLinks />
                </div>
            </div>
        </header>
    )
}

// const PhoneNumber: React.FC = () => {
//     const geoLocation = useGeolocation()
//     const phoneNumber = geoLocation.phone

//     if (!phoneNumber) return null

//     return (
//         <div className={styles.phoneNumberContainer}>
//             <a
//                 href={`tel:${phoneNumber}`}
//                 aria-label={`call ${phoneNumber}`}
//                 data-content-piece="phone"
//                 className={styles.link}
//             >
//                 <Icon name="circle-phone" padding={false} size="1.5x" ariaHidden={true} className={styles.linkIcon} />
//                 <span className={styles.linkLabel}>{phoneNumber}</span>
//             </a>
//             <div className={styles.linkExtraLabel}>
//                 <Trans>or contact your travel agent</Trans>
//             </div>
//         </div>
//     )
// }

const SupportLinks: React.FC = () => {
    const geoLocation = useGeolocation()
    const phoneNumber = geoLocation.phone
    const [state] = useECommerceMachine()

    const onClick = useCallback(() => {
        scrollToElement("faq")
    }, [])

    if (!phoneNumber) return null
    return (
        <div className={styles.phoneNumberContainer}>
            <div className={styles.linkExtraLabelRight}>
                <Trans>Support and assistance</Trans>
            </div>

            <div className={styles.links}>
                <a
                    href={`tel:${phoneNumber}`}
                    aria-label={`call ${phoneNumber}`}
                    data-content-piece="phone"
                    className={styles.link}
                >
                    <Icon
                        name="circle-phone"
                        padding={false}
                        size="1.5x"
                        ariaHidden={true}
                        className={styles.linkIcon}
                    />
                    <span className={styles.linkLabel}>{phoneNumber}</span>
                </a>

                {state.context.flowVersion.ui.faq.HeaderButton(state, { onClick })}
            </div>
        </div>
    )
}

export default Header
